/**
 * Our own accounts show up all over the admin lists — staff logins, demo
 * travelers and leftover test trips — and they drown out real signal. Anything
 * on a company domain counts as internal.
 */

export const INTERNAL_EMAIL_DOMAINS = ['dejavunomad.com'];

export const isInternalEmail = (email) => {
  const normalized = String(email || '').trim().toLowerCase();
  if (!normalized.includes('@')) return false;
  const domain = normalized.split('@').pop();
  return INTERNAL_EMAIL_DOMAINS.some(
    (internal) => domain === internal || domain.endsWith(`.${internal}`)
  );
};

/**
 * Filters a list by the email on each record. Records without a resolvable
 * email are kept, since we cannot prove they are ours.
 *
 * @param {Array} items
 * @param {(item: any) => string} emailOf where the owner's email lives
 */
export const withoutInternalAccounts = (items, emailOf = (item) => item?.email) => (
  (items || []).filter((item) => !isInternalEmail(emailOf(item)))
);

export const countInternalAccounts = (items, emailOf = (item) => item?.email) => (
  (items || []).filter((item) => isInternalEmail(emailOf(item))).length
);
